//#region src/users.ts
const PERSONALIZATION_MODAL_KEY = "personalization";

//#endregion
export { PERSONALIZATION_MODAL_KEY };
//# sourceMappingURL=users.mjs.map